<template>
<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <OsTestsForm v-if="os" :os="os" />
    <LoadingPage v-if="!os"/>
  </PageRowWrapper>

</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import OsTestsForm from '@/components/osTests/OsTestsForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'OsTests',
  components: {
    PageTitle,
    PageRowWrapper,
    OsTestsForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      os: state => state.os.osById
    })
  },
  methods: {
    ...mapActions('os', ['fetchById', 'cleanState'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
